import { IconCreditCard, IconCreditCardPay, IconHistory, IconLogout, IconSettings } from '@tabler/icons-react';
import { routes } from '~/shared/constants/routes';
import { type NavbarSubTab, type NavbarTab } from './components';

const isRouteActive = (route: string) => {
    return (pathname: string) => {
        return pathname === route;
    };
};

const hasActiveChild = (children: NavbarSubTab[]) => {
    return (pathname: string) => {
        return children.some((child) => {
            return child.isActive?.(pathname);
        });
    };
};

const historyChildren = [
    {
        icon: IconCreditCardPay,
        label: 'Выплаты',
        to: routes['payout-history'],
        isActive: isRouteActive(routes['payout-history']),
    },
    {
        icon: IconCreditCard,
        label: 'Прием',
        to: routes['payin-history'],
        isActive: isRouteActive(routes['payin-history']),
    },
];

const historyTab: NavbarTab = {
    icon: IconHistory,
    label: 'История заявок',
    to: routes.history,
    isActive: hasActiveChild(historyChildren),
    children: historyChildren,
};

export const tabs: NavbarTab[] = [
    {
        icon: IconCreditCardPay,
        label: 'Выплаты',
        to: routes.payout,
        isActive: isRouteActive(routes.payout),
    },
    {
        icon: IconCreditCard,
        label: 'Прием',
        to: routes.payin,
        isActive: isRouteActive(routes.payin),
    },
    historyTab,
];

export const mobileTabs: NavbarTab[] = [
    historyTab,
    {
        icon: IconSettings,
        label: 'Настройки',
        to: routes.settings,
        isActive: isRouteActive(routes.settings),
    },
];

export const logoutTab = (onLogout?: VoidFunction): NavbarTab => {
    return {
        icon: IconLogout,
        label: 'Выйти',
        onClick: onLogout,
    };
};
